export function assertIsError(error) {
    if (!(error instanceof Error))
        throw error;
}
export const get = (obj, path) => path.split('.').reduce((prevObj, key) => {
    if (!prevObj || typeof prevObj === 'string')
        return undefined;
    return prevObj[key];
}, obj);
const getNeutralLocale = (locale) => {
    const splitChar = locale.indexOf('_') > 0 ? '_' : '-';
    const [neutral] = locale.split(splitChar);
    return neutral;
};
export const mapToKnownLocale = (locales, locale, defaultLocale) => {
    if (locales[locale])
        return locale;
    const neutral = getNeutralLocale(locale);
    if (locales[neutral])
        return neutral;
    return defaultLocale;
};
//# sourceMappingURL=utils.js.map